// extracted by mini-css-extract-plugin
export default {"success":"LogoutCard_success__B5Uch","headline":"LogoutCard_headline__g-HVz","subheadline":"LogoutCard_subheadline__pvoVM","feedbackSent":"LogoutCard_feedbackSent__kbouW"};